import React, {  Component } from 'react';

export default class Loader extends Component {
  	render() {
    	return (
			<div className="loader-container">
			   <div className="overlay"></div>
			   <div className="loader">&nbsp;</div>
		   </div>
    	);
  	}
}



// WEBPACK FOOTER //
// ./src/App/components/common/loader.js